import ComplianceTargeting from '../../components/picture-ai/ComplianceTargeting.jsx';
import CriteriaGrid from '../../components/picture-ai/CriteriaGrid.jsx';
import QuestionVariantMatrix from '../../components/picture-ai/QuestionVariantMatrix.jsx';
import RuleToggles from '../../components/picture-ai/RuleToggles.jsx';
import RuleList from '../../components/picture-ai/RuleList.jsx';
import ComplianceVerdict from '../../components/picture-ai/ComplianceVerdict.jsx';
import HiddenVerdict from '../../components/picture-ai/HiddenVerdict.jsx';
import VisualContextResult from '../../components/picture-ai/VisualContextResult.jsx';

/**
 * Named widgets and result views an agent's descriptor may ask for.
 *
 * An agent that sticks to the generic field kinds needs nothing here. One that wants a richer
 * editor or presentation names a component, which this file resolves — and a name this build does
 * not know falls back rather than breaking the screen, because the backend can ship an agent
 * before the frontend catches up.
 */
export const WIDGETS = {
  'compliance-targeting': ComplianceTargeting,
  'criteria-grid': CriteriaGrid,
  'question-variant-matrix': QuestionVariantMatrix,
  'rule-toggles': RuleToggles,
  'rule-list': RuleList,
};

export const RESULT_VIEWS = {
  'compliance-verdict': ComplianceVerdict,
  'hidden-verdict': HiddenVerdict,
  'visual-context': VisualContextResult,
};

export const resolveWidget = (name) => WIDGETS[name] || null;
export const resolveResultView = (name) => RESULT_VIEWS[name] || null;
